import FullIndex from './full.vue';
import Overview from './overview.vue';
import MobOverview from './mob-overview.vue';
import MobFull from './mob-full.vue';

export const componentMap = {
	full: FullIndex,
	overview: Overview,
	'mob-overview': MobOverview,
	'mob-full': MobFull
};  